export default "/images/marker-icon.png";